<div id="wt">
  <button type="button" class="close text-primary m-2" aria-label="Close"
    (click)="activeModal.dismiss('Cross click')">
    <i class="fas fa-times-circle"></i>
  </button>
  <div class="modal-header d-flex justify-content-center border-bottom-0">
    <div>
      <h5 class="modal-title">Asignar Abogado</h5>
    </div>
  </div>
  <div class="modal-body">
    <form [formGroup]="form" (ngSubmit)="onSubmit()" class="form-group">

      <div class="form-group offset-2 col-8">
        <select class="ml-1 mr-1 mt-4 mb-4 form-control" id="users" formControlName="userSelected">
          <option value="0">Seleccionar</option>
          @for (user of users; track user) {
            <option [ngValue]="user">
            {{ user.name }}</option>
          }
        </select>
      </div>

      <div class="modal-footer border-top-0 justify-content-center">
        <button type="submit" class="btn btn-outline-primary bg-white rounded-pill text-dark font-weight-bold" style="width: 120px" [disabled]="savingLawyer">
          @if (savingLawyer) {
            <div>
              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              Cargando...
            </div>
          }
          @if (!savingLawyer) {
            <span>Asignar</span>
          }
        </button>
      </div>
    </form>
  </div>
</div>